<template>
  <div class="form" v-e2e="'formulario-endereco'" v-e2e:data-valor="'componente'">
    <slot name="titulo">
      <p><strong>Qual o endereço?</strong></p>
    </slot>
    <br/>
    <div class="columns is-multiline is-2 mb-0">
      <div class="column is-3">
        <TrfCepInput
          label="CEP"
          id="form-endereco-cep"
          v-model="formData.cep"
          ref="campoEnderecoCep"
          v-e2e="'cep-form-endereco'"
          :required="false"
          @cepInformations="setCepInformations"
          @update:isLoading="setLoadingCep"
        ></TrfCepInput>
      </div>
      <div class="column">
        <TrfInput
          label="Endereço"
          placeholder=""
          margin="0"
          maxLength="50"
          id="form-endereco-endereco"
          v-model="formData.endereco"
          ref="campoEnderecoEndereco"
          v-e2e="'endereco-form-endereco'"
          :required="false"
          :isDisabled="isLoadingCep"
        ></TrfInput>
      </div>
      <div class="column is-narrow">
        <TrfNumberInput
          label="Número"
          placeholder=""
          margin="0"
          id="form-endereco-numero"
          v-model="formData.numero"
          maxLength="10"
          :desabilitarInput="formData.semNumero || isLoadingCep"
          ref="campoEnderecoNumero"
          v-e2e="'numero-form-endereco'"
          :required="false"
        ></TrfNumberInput>
      </div>
      <div class="column is-narrow is-align-content-center">
        <TrfCheckbox
          class="pb-0 pt-5"
          label="Sem número"
          id="form-endereco-semnumero"
          v-model="formData.semNumero"
          ref="campoEnderecoSemNumero"
          v-e2e="'semNumero-form-endereco'"
          :required="false"
          @update:modelValue="$event => setSemNumero($event)"
        >
        </TrfCheckbox>
      </div>
      <div class="column is-12">
        <TrfInput
          label="Complemento"
          placeholder=""
          margin="0"
          id="form-endereco-complemento"
          v-model="formData.complemento"
          ref="campoEnderecoComplemento"
          maxLength="60"
          v-e2e="'complemento-form-endereco'"
          :required="false"
          :isDisabled="isLoadingCep"
        ></TrfInput>
      </div>
      <div class="column is-3">
        <TrfInput
          label="Bairro"
          placeholder=""
          margin="0"
          id="form-endereco-bairro"
          v-model="formData.bairro"
          ref="campoEnderecoBairro"
          :maxLength="bairroMaxLength.toString()"
          v-e2e="'bairro-form-endereco'"
          :required="false"
          :isDisabled="isLoadingCep"
        ></TrfInput>
      </div>
      <div class="column is-5">
        <TrfInput
          label="Cidade"
          placeholder=""
          margin="0"
          id="form-endereco-cidade"
          v-model="formData.cidade"
          ref="campoEnderecoCidade"
          maxLength="100"
          v-e2e="'cidade-form-endereco'"
          :required="false"
          :isDisabled="isLoadingCep"
        ></TrfInput>
      </div>
      <div class="column is-2">
        <TrfSelect
          :options="listagemUFs"
          :noOptionsText="'UFs não encontradas'"
          label="UF"
          idSelect="form-endereco-uf"
          @valueSelect="$event => setUF($event)"
          placeholder=""
          :required="false"
          ref="campoEnderecoUf"
          :loadingData="loadingSelects"
          :disabled="loadingSelects || isLoadingCep"
          v-e2e="'uf-form-endereco'"
        ></TrfSelect>
      </div>
      <div class="column is-2">
        <TrfSelect
          :options="listagemPaises"
          :noOptionsText="'Países não encontradas'"
          label="País"
          idSelect="form-endereco-pais"
          @valueSelect="$event => setPais($event)"
          placeholder=""
          :required="false"
          ref="campoEnderecoPais"
          :loadingData="loadingSelects"
          :disabled="loadingSelects || isLoadingCep"
          v-e2e="'pais-form-endereco'"
        ></TrfSelect>
      </div>
    </div>
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { camposEnderecoStore } from '../../stateManagement/camposEndereco';
import Endereco from '../../views/Legalize/CadastroDeProcessos/Models/endereco.model';
  
  export default {
    name: 'TrfFormularioBaseEndereco',
    expose: ['inicializarCampos', 'limparCampos'],
    emits: ['update:form-data'],
    components: {
      TrfInput: defineAsyncComponent(() => import('../Input/index.vue')),
      TrfNumberInput: defineAsyncComponent(() => import('../Input/TrfNumberInput.vue')),
      TrfCheckbox: defineAsyncComponent(() => import('../Checkbox/index.vue')),
      TrfSelect: defineAsyncComponent(() => import('../Select/index.vue')),
      TrfCepInput: defineAsyncComponent(() => import('../Input/TrfCepInput.vue'))
    },
    data() {
      return {
        formData: new Endereco(),
        listagemUFs: [],
        listagemPaises: [],
        loadingSelects: true,
        isLoadingCep: false,
        camposEnderecoStore: camposEnderecoStore,
        bairroMaxLength: 50
      };
    },
    computed: {
    },
    watch: {
      formData: {
        immediate: true,
        handler() {
          this.$emit('update:form-data', this.formData)
        },
        deep: true
      },
      'camposEnderecoStore.isLoadingEstados': {
        immediate: true,
        handler() {
          if(!camposEnderecoStore.isLoadingEstados) {            
            this.listagemUFs = camposEnderecoStore.estados;
          }
        },
      },
      'camposEnderecoStore.isLoadingPaises': {
        immediate: true,
        handler() {
          if(!camposEnderecoStore.isLoadingPaises) {
            this.listagemPaises = camposEnderecoStore.paisesSigla; 
          }
        },
      }
    },
    methods: {
      async iniciarCamposSelects() {
        this.loadingSelects = true;
        await camposEnderecoStore.adquirirTodosOsCampos();
        this.listagemUFs = camposEnderecoStore.estados;
        this.listagemPaises = camposEnderecoStore.paisesSigla;
        this.loadingSelects = false;
      },
      inicializarCampos(dados){
        this.formData.updateDados(dados);
        this.inicializarSelects(this.formData);
      },
      inicializarSelects(){
        this.selecionarEstado();
        this.selecionarPais();
      },
      selecionarValorDoFormulario(refNome, propriedadeFormulario) { 
        if(!this.$refs[refNome]) return;
        if(!this.formData[propriedadeFormulario]) return;
        
        this.$refs[refNome].selecionar(this.formData[propriedadeFormulario]);
      },
      selecionarEstado() {
        this.selecionarValorDoFormulario('campoEnderecoUf', 'estado');
      },
      selecionarPais() {
        this.selecionarValorDoFormulario('campoEnderecoPais', 'pais');
      },
      setCEP(valor) {
        this.formData.cep = valor;
      },
      setSemNumero(valor) {
        this.formData.numero = null;
        this.formData.semNumero = valor;
      },
      setUF(valor) {
        this.formData.estado = valor;
      },
      setPais(valor) {
        this.formData.pais = valor;
      },
      setEndereco(valor) {
        this.formData.endereco = valor;
      },
      setComplemento(valor) {
        this.formData.complemento = valor;
      },
      setBairro(valor) {
        this.formData.bairro = valor.slice(0, this.bairroMaxLength);
      },
      setCidade(valor) {
        this.formData.cidade = valor;
      },
      setNumero(valor) {
        this.formData.numero = valor;
      },
      limparCampos() {
        this.formData = new Endereco();
        this.$refs.campoEnderecoCep.limparInput();
        this.$refs.campoEnderecoCep.limparValidacao();
        this.$refs.campoEnderecoEndereco.limparInput();
        this.$refs.campoEnderecoEndereco.limparValidacao();
        this.$refs.campoEnderecoComplemento.limparInput();
        this.$refs.campoEnderecoComplemento.limparValidacao();
        this.$refs.campoEnderecoBairro.limparInput();
        this.$refs.campoEnderecoBairro.limparValidacao();
        this.$refs.campoEnderecoCidade.limparInput();
        this.$refs.campoEnderecoCidade.limparValidacao();
        this.$refs.campoEnderecoNumero.limparInput();
        this.$refs.campoEnderecoNumero.limparValidacao();
        this.formData.semNumero = false;
        this.$refs.campoEnderecoUf.limparSelect();
        this.$refs.campoEnderecoUf.limparValidacao();
        this.$refs.campoEnderecoPais.limparSelect();
        this.$refs.campoEnderecoPais.limparValidacao();
      },
      setCepInformations(cepInformations) {
        const uf = this.listagemUFs.find(uf => uf.label == cepInformations.uf);
        if(uf) {
          this.$refs.campoEnderecoUf.selecionar(uf.value);
        } else {
          this.$refs.campoEnderecoUf.limparSelect();
          this.$refs.campoEnderecoUf.limparValidacao();
          this.setUF(null);
        }
        if (this.listagemPaises.find(pais => pais.value == '105')) {
          this.$refs.campoEnderecoPais.selecionar('105');
        }

        this.setEndereco(cepInformations.logradouro);
        this.setComplemento(cepInformations.complemento);
        this.setBairro(cepInformations.bairro);
        this.setCidade(cepInformations.localidade);
        this.setNumero(cepInformations.numero);
      },

      setLoadingCep(valor) {
        this.isLoadingCep = valor;
      },
    },
    async mounted() {
      await this.iniciarCamposSelects();
    },
  };
  </script>
  <style lang="scss" scoped>
  .multiselect-econtador {
    margin: 0;
  }
  .columns.is-0 > .column, .columns.is-gapless > .column {
  padding-left: 0;
  padding-right: 0;
}
.columns.is-1 {
  margin-left:-0.25em;
  margin-right:-0.25em;
 & > .column {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  } 
}
.columns.is-2 > .column {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.columns.is-3 > .column {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.columns.is-4 > .column {
  padding-left: 1rem;
  padding-right: 1rem;
}
.columns.is-5 > .column {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.columns.is-6 > .column {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.columns.is-7 > .column {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.columns.is-8 > .column {
  padding-left: 2rem;
  padding-right: 2rem;
}
  </style>
  